module.exports = __webpack_public_path__ + "static/media/tranquil.b93088ea.png";